export default __webpack_public_path__ + "static/banner_cyborgcultures-53822f680abbf78fc25501518a649cbd.png";